import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from 'actions/chargeActions';
const apiUrls = require('constants/apiUrls');
import * as mouseFlowUtils from '../utils/mouseFlowUtils';
import {
  TAG_ADD_CHARGE
  , TAG_UPDATE_CHARGE
  , TAG_REMOVE_CHARGE
}
  from '../constants/mouseFlow';
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {

  addCharge: (request, store, orderId) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    request.userName = state
      .getIn(['user', 'userId']);

    const accountNumber = state
      .getIn([
        'workOrder',
        'workOrderDetails',
        orderId,
        'customerDetails',
        'details',
        'accountNumber'
      ]);

    request.customerAccount = accountNumber;

        if (!request.comment) {
            delete request.comment;
        }

    mouseFlowUtils.setNewPageView(apiUrls.CHARGE_ADD_URL);
    mouseFlowUtils.setTag(TAG_ADD_CHARGE);

    return ajax({
      url: apiUrls.CHARGE_ADD_URL,
      method: 'POST',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  },
  updateCharge: (request, store, orderId) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    request.userName = state
      .getIn(['user', 'userId']);

    const accountNumber = state
      .getIn([
        'workOrder',
        'workOrderDetails',
        orderId,
        'customerDetails',
        'details',
        'accountNumber'
      ]);

        if (!request.comment) {
            delete request.comment;
        }

    request.customerAccount = accountNumber;
    mouseFlowUtils.setNewPageView(apiUrls.CHARGE_UPDATE_URL);
    mouseFlowUtils.setTag(TAG_UPDATE_CHARGE);

    return ajax({
      url: apiUrls.CHARGE_UPDATE_URL,
      method: 'PUT',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  },
  removeCharge: (request, store, orderId) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    request.userName = state
      .getIn(['user', 'userId']);

    const accountNumber = state
      .getIn([
        'workOrder',
        'workOrderDetails',
        orderId,
        'customerDetails',
        'details',
        'accountNumber'
      ]);

    if (!request.comment) {
        delete request.comment;
    }

    request.customerAccount = accountNumber;
    mouseFlowUtils.setNewPageView(apiUrls.CHARGE_REMOVE_URL);
    mouseFlowUtils.setTag(TAG_REMOVE_CHARGE);

    return ajax({
      url: apiUrls.CHARGE_REMOVE_URL,
      method: 'POST',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  },
  submitUnnecessaryTruckRoll: (request, store, orderId) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    request.userId = state.getIn(['user', 'userId']);
    request.mobiServiceOrder = orderId;

        if (!request.comment) {
            delete request.comment;
        }

    return ajax({
      url: apiUrls.UNNECESSARY_TRUCK_ROLL_URL,
      method: 'POST',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + accessToken
      }
    });
  },
};

export const addChargeEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.CHARGE_ADD_STARTED)
  .mergeMap(action => call(api.addCharge, action.request, store, action.orderId).map((payload) => {
    return (actions.chargeAddFinished(payload.response, action.orderId));
  }).catch(() => of(actions.chargeAddFailed(action.request, action.orderId))));

export const updateChargeEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.CHARGE_UPDATE_STARTED)
  .mergeMap(action => call(api.updateCharge, action.request, store, action.orderId).map(() => {

    return (actions.chargeUpdateFinished(action.request, action.orderId));
  }).takeUntil(action$.ofType(types.CHARGE_UPDATE_CANCELLED)).catch(() => of(actions.chargeUpdateFailed(action.request, action.orderId))));

export const removeChargeEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.CHARGE_REMOVE_STARTED)
  .mergeMap(action => call(api.removeCharge, action.request, store, action.orderId).map(() => {
    return (actions.chargeRemoveFinished(action.request, action.orderId));
  }).catch(error => of(actions.chargeRemoveFailed(error, action.orderId))));

export const unnecessaryTruckRollEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.SUBMIT_UNNECESSARY_TRUCK_ROLL_STARTED)
  .mergeMap(action => call(api.submitUnnecessaryTruckRoll, action.request, store, action.orderId).map((payload) => {
    return (actions.submitUnnecessaryTruckRollFinished(payload.response, action.orderId));
  }).catch(() => of(actions.submitUnnecessaryTruckRollFailed(action.request, action.orderId))));



// WEBPACK FOOTER //
// ./src/epics/chargeEpic.js